import CreateAnnouncementContainer from "../containers/CreateAnnouncementContainer";

const CreateAnnouncementPage = () => {
  return (
    <CreateAnnouncementContainer />
  );
};

export default CreateAnnouncementPage;
